export default __webpack_public_path__ + "static/media/contact.1b1f7426.jpg";